import { useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function PhonePage() {
  const [phone, setPhone] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userId = searchParams.get("userId");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token"); 
    console.log(token);
    const res = await axios.post("http://localhost:5000/api/auth/google-complete",
  { phone },
  {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }
);

    navigate(res.data.user.role === "admin" ? "/admin" : "/student");
  };

  return (
    <div className="flex flex-col items-center mt-20">
      <h2 className="text-2xl font-bold mb-4">Enter your phone number</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Phone number"
          className="border p-2 rounded"
        />
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
          Continue
        </button>
      </form>
    </div>
  );
}
